export default __webpack_public_path__ + "static/media/main-bg.8e6abb37.png";